<script setup>
import ExplainDirectiveCard from '@/Pages/DomainAnalysis/Partials/ExplainDirectiveCard.vue';
import StatusIcon from '@/Pages/Common/StatusIcon.vue';
import actionType from '@/Common/Enum/ActionType.js';
import ExplainDirectiveRow from '@/Pages/DomainAnalysis/Partials/ExplainDirectiveRow.vue';

defineProps({
  record: Object
});
</script>

<template>
  <div v-if="record.has_logo" class="mt-2">
    <div class="mt-4 pl-6 font-bold md:pl-8">
      {{ $t('domain_analysis.partials.explain_bimi_logo.logo') }}
    </div>
    <ExplainDirectiveCard>
      <ExplainDirectiveRow class="gap-0!">
        {{ $t('domain_analysis.partials.explain_bimi_logo.logo_url') }}
        <template #detail>
          <div class="text-wrap break-all">
            {{ record.logo_url }}
          </div>
        </template>
        <template #icon>
          <StatusIcon
            v-tooltip="
              record.has_valid_logo
                ? $t('domain_analysis.partials.explain_bimi_logo.no_error')
                : $t('domain_analysis.partials.explain_bimi_logo.invalid_logo')
            "
            :action-type="
              record.has_valid_logo
                ? actionType.NO_ACTION
                : actionType.ACTION_REQUIRED
            "
          />
        </template>
      </ExplainDirectiveRow>

      <ExplainDirectiveRow v-if="record.has_valid_logo" class="gap-0!">
        {{ $t('domain_analysis.partials.explain_bimi_logo.logo_preview') }}
        <template #detail>
          <div class="flex flex-1 justify-between gap-4">
            <div
              class="flex flex-1 flex-wrap items-center justify-center gap-10 rounded-lg bg-white p-4"
            >
              <img :src="record.logo_url" width="125" />
              <img :src="record.logo_url" width="125" class="rounded-full" />
            </div>

            <div
              class="flex flex-1 flex-wrap items-center justify-center gap-10 rounded-lg bg-black p-4"
            >
              <img :src="record.logo_url" width="125" class="max-w-36" />
              <img
                :src="record.logo_url"
                width="125"
                class="max-w-36 rounded-full"
              />
            </div>
          </div>
        </template>
      </ExplainDirectiveRow>

      <ExplainDirectiveRow class="gap-0!">
        {{ $t('domain_analysis.partials.explain_bimi_logo.logo_size') }}
        <template #detail>
          <div class="text-wrap break-all">{{ record.logo_size }} Bytes</div>
        </template>
      </ExplainDirectiveRow>
    </ExplainDirectiveCard>
  </div>
</template>
